import React, { ComponentType, createContext, useContext, useMemo } from 'react';
import { getBrandByDomainAndTheme } from './configurations/Utils';
import { observer } from 'mobx-react';
import { BrandTypes, Themes } from './enums';
import { Brand } from './types';
import { Routes } from 'shared/constants/routes';
import { updateAppConfigurationForChangedBrand } from 'config';

const BrandContext = createContext<Brand | null>(getBrandByDomainAndTheme(Themes.Default));

export const useBrand = (): Brand => {
  const context = useContext<Brand | null>(BrandContext);
  return context ?? ({} as Brand);
};

const getBrandValue = (isLoginPage: boolean, currUserTheme?: string): Brand => {
  currUserTheme = currUserTheme ?? Themes.Default;
  if (isLoginPage) {
    return getBrandByDomainAndTheme(currUserTheme);
  }

  return getBrandByDomainAndTheme(currUserTheme, BrandTypes.Umbrella);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const withBrandContextProvider = <P extends object>(Component: ComponentType<P>, rootStore: any) => {
  // eslint-disable-next-line no-undef
  const BrandContextProvider = (props: Readonly<P>) => {
    const isLoginPage = useMemo(() => {
      const path = window.location.pathname;
      const inHomeButLoggedOut = path === '/';

      return (
        !rootStore.usersStore.authUserKey ||
        inHomeButLoggedOut ||
        path.includes(Routes.LOG_IN) ||
        path.includes(Routes.REGISTER)
      );
    }, []);

    const currUserTheme = rootStore.usersStore.getCurrDisplayedUserTheme();

    const brandValue = useMemo(() => getBrandValue(isLoginPage, currUserTheme), [isLoginPage, currUserTheme]);
    updateAppConfigurationForChangedBrand(brandValue);
    return (
      <BrandContext.Provider value={brandValue}>
        <Component {...props} />
      </BrandContext.Provider>
    );
  };

  return observer(BrandContextProvider);
};
